/**
 * Created by zlj on 2020/3/30.
 */
import introduction from "../components/commerical/introduction.vue"


import dataSources from "../components/commerical/product/dataSources.vue"
import basicProj from "../components/commerical/product/project.vue"
import product from "../components/commerical/product/product.vue"
import frame from "../components/commerical/product/frame.vue"
let childIcon='el-icon-bangzhu';
var menus = {
  "name": "公共资源库",
  "child": [
    {
      "iconCls": "el-icon-s-platform",
      "name": "网站介绍",
      component: introduction,
      "visible": true,
      open: true,

    },
    {
      "iconCls": "el-icon-place",
      "name": "数据库",
      "visible": true,
      open: true,
      "child": [
        {
          "iconCls": childIcon,
          "name": "数据资源",
          component: dataSources,
          "visible": true
        }
      ]
    },
    {
      "iconCls": "el-icon-edit",
      "name": "项目库",
      "visible": true,
      open: true,
      "child": [
        {
          "iconCls": childIcon,
          "name": "基础项目",
          component: basicProj,
          "visible": true
        }
      ]
    },
   {
      "iconCls": "el-icon-s-help",
      "name": "产品库",
      "visible": true,
      open: true,
      "child": [
        {
          "iconCls": childIcon,
          "name": "基础产品",
          component: product,
          "visible": true
        }
      ]
    },
    {
      "iconCls": "el-icon-setting",
      "name": "框架库",
      "visible": true,
      open: true,
      "child": [
        {
          "iconCls": childIcon,
          "name": "核心框架",
          component: frame,
          "visible": true
        }
      ]
    }
  ]
};

export default menus



// WEBPACK FOOTER //
// ./src/transform/menus.js